export interface IUserApiResponse {
  content: IUser[];
  pageNum: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  numberOfElements: number;
}

export interface IUser {
  id: number;
  email: string;
  username: null;
  firstName: string;
  lastName: string;
  name: string;
  status: EUserStatus;
  isActive: boolean;
  mustChangePassword: boolean;
  role: Role;
  createdAt: string;
  updatedAt: string;
}

export interface Role {
  id: number;
  name: string;
}
export enum EUserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}
export interface UserFilters {
  search?: string;
  role?: string;
  roleId?: number;
  ownerId?: number;
  status?: EUserStatus;
  applicationId?: number;
  application?: string;
  dateFrom?: Date | null;
  dateTo?: Date | null;
  date?: Date | null;
  historyStatus?: string;
}
export interface RepositoryFilters {
  search?: string;
  topicId?: string;
  ownerId?: string;
  createdFrom?: string | null;
  createdTo?: string | null;
}
export interface ICreateUser {
  email: string;
  firstName: string;
  lastName: string;
  roleId: number;
}
export enum EUserRole {
  ApplicationUser = 'application_user',
  AppAdmin = 'app_admin',
  ComponentAdmin = 'components_admin',
}
